import { Routes } from '@angular/router';
import {
	PublicPagesWrapperComponent
} from '@infodocs/shared/components/public-pages-wrapper/public-pages-wrapper.component';

/** Temporary POC routes for ID24-3894 — Sign Up / Sign In with Xero. */
export const xeroAuthRoutes: Routes = [
	{
		path: 'xero-register',
		component: PublicPagesWrapperComponent,
		children: [
			{
				path: '',
				loadComponent: () =>
					import('./pages/xero-register-page/xero-register-page.component').then(
						(m) => m.XeroRegisterPageComponent
					),
				data: { headerType: 'withLogin' },
			},
		],
	},
	{
		path: 'xero-login',
		component: PublicPagesWrapperComponent,
		children: [
			{
				path: '',
				loadComponent: () =>
					import('./pages/xero-login-page/xero-login-page.component').then(
						(m) => m.XeroLoginPageComponent
					),
				data: { headerType: 'withLogin' },
			},
		],
	},
	{
		path: 'xero-auth',
		component: PublicPagesWrapperComponent,
		children: [
			{
				path: 'callback',
				loadComponent: () =>
					import('./pages/xero-auth-callback-page/xero-auth-callback-page.component').then(
						(m) => m.XeroAuthCallbackPageComponent
					),
				data: { headerType: 'simple' },
			},
		],
	},
];
